'use client';
import { useRouter } from 'next/navigation'
import React from 'react'
import { NavWrapper } from './styles'
import { useLocale } from '../../providers'

export function Nav() {
    const router = useRouter()
    const { getText } = useLocale()
    const homeLinkLabel = getText('homeLinkLabel')

    return (
        <NavWrapper>
            <button onClick={() => { router.push('/') }}>
                ← {homeLinkLabel}
            </button>
        </NavWrapper>
    )
}
